import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

interface BasicTableProps {
  rows: any
}

const initCap = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export default function BasicTable({ rows }: BasicTableProps) {
  const cols = Object.keys(rows?.[0] || {})
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            {cols?.map((col: string) => {
              return <TableCell>{initCap(col)}</TableCell>
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row: any) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              {cols.map((col: string) => {
                return <TableCell>{row[col]}</TableCell>
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
